import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import UploadPage from "@/pages/UploadPage";
import BatchesPage from "@/pages/BatchesPage";
import BatchDetailPage from "@/pages/BatchDetailPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import AdminComunasPage from "@/pages/AdminComunasPage";
import AdminDocumentsPage from "@/pages/AdminDocumentsPage";
import AdminSapByClientPage from "@/pages/AdminSapByClientPage";
import AdminRdaPage from "@/pages/AdminRdaPage";
import ClientRdaPage from "@/pages/ClientRdaPage";
import AdminConsolidadoPage from "@/pages/AdminConsolidadoPage";
import AdminCediblePage from "@/pages/AdminCediblePage";
import ClientCediblePage from "@/pages/ClientCediblePage";
import AdminFacturasPage from "@/pages/AdminFacturasPage";
import ClientFacturasPage from "@/pages/ClientFacturasPage";
import AdminClientesPage from "@/pages/AdminClientesPage";
import AdminClienteDetailPage from "@/pages/AdminClienteDetailPage";
import ApiPage from "@/pages/ApiPage";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/upload"
              element={
                <ProtectedRoute>
                  <UploadPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/batches"
              element={
                <ProtectedRoute>
                  <BatchesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/batches/:batchId"
              element={
                <ProtectedRoute>
                  <BatchDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute adminOnly>
                  <AdminUsersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/comunas"
              element={
                <ProtectedRoute adminOnly>
                  <AdminComunasPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/documents"
              element={
                <ProtectedRoute adminOnly>
                  <AdminDocumentsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/sap"
              element={
                <ProtectedRoute adminOnly>
                  <AdminSapByClientPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/rda"
              element={
                <ProtectedRoute adminOnly>
                  <AdminRdaPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/consolidado"
              element={
                <ProtectedRoute adminOnly>
                  <AdminConsolidadoPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/cedible"
              element={
                <ProtectedRoute adminOnly>
                  <AdminCediblePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cedibles"
              element={
                <ProtectedRoute>
                  <ClientCediblePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/facturas"
              element={
                <ProtectedRoute adminOnly>
                  <AdminFacturasPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/facturas"
              element={
                <ProtectedRoute>
                  <ClientFacturasPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/clientes"
              element={
                <ProtectedRoute adminOnly>
                  <AdminClientesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/clientes/:userId"
              element={
                <ProtectedRoute adminOnly>
                  <AdminClienteDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/api-docs"
              element={
                <ProtectedRoute>
                  <ApiPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/entregas"
              element={
                <ProtectedRoute>
                  <ClientRdaPage />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster
            position="top-right"
            richColors
            closeButton
            toastOptions={{
              style: {
                fontFamily: "IBM Plex Sans, sans-serif",
                borderRadius: 0,
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
